import { useEffect, useState } from 'react';

import { MOCK_STREAM_CURRENCY } from 'e2e-tests/mocks/mock-rooms';

import { ConnectWallet } from 'shared/components/sections/connect-wallet/connect-wallet';
import { useAccount } from 'shared/hooks/use-web3';
import useMediaQuery from 'shared/hooks/useMediaQuery';
import { useNewRoomStore } from 'shared/store/room-store';
import { useStreamStore } from 'shared/store/stream-store';
import { useUIStore } from 'shared/store/uiStore';
import { isMocked } from 'shared/utils/isMocked';
import { normalizeRoomData } from 'shared/utils/normalizeData';
import { CurrencyType } from 'shared/web3';

import { StreamRoomDesktop, StreamRoomMobile } from './components/stream-room';

export const StreamRoom = () => {
  const isTablet = useMediaQuery('(max-width: 1200px)');
  const { isConnected } = useAccount();
  const { connectWalletModal } = useUIStore();

  // NOTE: guest mode !== snapshot. Guest = no wallet. Snapshot = explicit replay.
  const [isGuestMode, setIsGuestMode] = useState(false);

  const [streamCurrency, setStreamCurrency] = useState<CurrencyType | undefined>(undefined);
  const { clearRoomStore } = useNewRoomStore();
  const { clearStore } = useStreamStore();

  useEffect(() => {
    const data = (window as any)?.__STREAM_META__;
    if (data) {
      const normalized = normalizeRoomData(data);

      useNewRoomStore.setState({
        room: normalized.room,
        rounds: normalized.rounds,
        wins: normalized.wins,
        initialLoading: false,
      });

      useStreamStore.setState({
        currentPhase: 'playersThinking',
        currentRound: normalized.currentRound,
        isDone: false,
        isProcessing: false,
      });

      setStreamCurrency(normalized.streamCurrency as CurrencyType);
      // Kick animations for replay
      useStreamStore.getState().processNextAnimation();
    }

    return () => {
      useNewRoomStore.getState().stopPolling();
      clearStore();
      clearRoomStore();
    };
  }, [clearStore, clearRoomStore]);

  useEffect(() => {
    setIsGuestMode(!isConnected);
  }, [isConnected]);

  useEffect(() => {
    if (isMocked) {
      setStreamCurrency(MOCK_STREAM_CURRENCY);
      setIsGuestMode(true);
    }
  }, []);

  if (connectWalletModal.show && !isConnected) {
    return (
      <ConnectWallet title={'common.connectWallet'} description={'pages.dailyQuests.connectDesc'} />
    );
  }

  return isTablet ? (
    <StreamRoomMobile isGuestMode={isGuestMode} streamCurrency={streamCurrency} />
  ) : (
    <StreamRoomDesktop isGuestMode={isGuestMode} streamCurrency={streamCurrency} />
  );
};
